module.exports = "/images/webde.png?15b531f9ec2916af4da90b57a86e1052";